import React from 'react';
import PropTypes from 'prop-types';
import Downshift from 'downshift';
import { withStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import Paper from '@material-ui/core/Paper';
import MenuItem from '@material-ui/core/MenuItem';
import styles from './style'

function renderSuggestion({ suggestion, itemProps, itemToSelectOption }) {
  return (
    <MenuItem
      {...itemProps}
      component="div"
      style={{
        fontWeight: 400,
      }}  
    >
      {itemToSelectOption(suggestion)}
    </MenuItem>
  );
}

renderSuggestion.propTypes = {
  highlightedIndex: PropTypes.number,
  index: PropTypes.number,
  itemProps: PropTypes.object,
  selectedItem: PropTypes.string,
  suggestion: PropTypes.shape({ label: PropTypes.string }).isRequired,
};

export class DropDownSearchListClass extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: props.searchString || '',
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.searchString !== this.props.searchString) {
      this.setState({ inputValue: this.props.searchString });
    }
  }

  handleInputChange = value => {
    this.setState({ inputValue: value });
    this.props.onInputChange(value);
  };

  handleSelectChange = suggestion => {
    if (this.props.fillInputOnSelect && this.props.itemToShowSelected) {
      const value = this.props.itemToShowSelected(suggestion);
      this.setState({ inputValue: value });
      this.props.onInputChange(value); 
    }
    else if (this.props.fillInputOnSelect) {
      const value = this.props.itemToSelectOption(suggestion);
      this.setState({ inputValue: value });
      this.props.onInputChange(value); 
    } else {
      this.setState({ inputValue: '' });
      this.props.onInputChange(''); 
    }
    this.props.onSelectChange(suggestion);
  };

  render() {
    const { label, placeholder, items, itemToSelectOption, itemKey, classes, statusMessage } = this.props;

    return (
      <div>
        <Downshift id="downshift-simple">
          {({
            getInputProps,
            getItemProps,
            getMenuProps,
            highlightedIndex,
            isOpen,
            selectedItem,
          }) => (
            <div className={classes.downshiftContainer}>
              <TextField
                fullWidth={true}
                InputProps={{
                  ...getInputProps({
                    placeholder,
                    value: this.state.inputValue,
                    label,
                    onChange: e => this.handleInputChange(e.target.value),
                  }),
                }}
              />
              <div {...getMenuProps()}>
                {isOpen ? (
                  <Paper square className={classes.paper}>
                    <FormHelperText className={classes.formHelperText}>
                      {statusMessage}
                    </FormHelperText>
                    {items.map((suggestion, index) =>
                      renderSuggestion({
                        suggestion,
                        index,
                        itemProps: getItemProps({ key: itemKey(suggestion), onClick: () => this.handleSelectChange(suggestion), item: '' }),
                        highlightedIndex,
                        selectedItem,
                        onSelectChange: this.handleSelectChange,
                        itemToSelectOption,
                      })
                    )}
                  </Paper>
                ) : null}
              </div>
            </div>
          )}
        </Downshift>
      </div>
    );
  }
}

DropDownSearchListClass.propTypes = {
  searchString: PropTypes.string.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  onInputChange: PropTypes.func.isRequired,
  onSelectChange: PropTypes.func.isRequired,
  items: PropTypes.array.isRequired,
  itemToSelectOption: PropTypes.func.isRequired,
  itemToShowSelected: PropTypes.func,
  itemKey: PropTypes.func.isRequired,
  statusMessage: PropTypes.string,
  fillInputOnSelect: PropTypes.bool,
};

export const reducePayload = (obj) => {return {[obj.propertyName]:obj.val} }

export const DropDownSearchList = withStyles(styles, { withTheme: true })(DropDownSearchListClass)

export default DropDownSearchList